module.exports = __webpack_public_path__ + "static/media/craft.e4e99a31.png";